import React, { useState, useEffect } from "react";
import { Drawer, Paper } from "@mui/material";
import { NavLink } from "react-router-dom";
import { HiMiniBookOpen, HiMiniRectangleStack } from "react-icons/hi2";
import { MdMoreHoriz, MdTipsAndUpdates } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import {
  BiSolidDashboard,
  BiSolidPurchaseTag,
  BiSupport,
} from "react-icons/bi";
import { More } from "@mui/icons-material";
import { IoCloseOutline } from "react-icons/io5";

export default function BottomNav() {
  const [showBottomNav, setShowBottomNav] = useState(false);
  const [showBottomDrawer, setShowBottomDrawer] = useState(false);
  useEffect(() => {
    function handleResize() {
      setShowBottomNav(window.innerWidth <= 1024);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setShowBottomDrawer(open);
    };

  return (
    <>
      {showBottomNav && (
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 500,
            fontSize: "14px",
          }}
          elevation={3}
        >
          <div className="bottom-nav">
            <div className="bottom-nav-item">
              <NavLink to="/" className="bottom-block">
                <div className="bottom-nav-icon">
                  <BiSolidDashboard size={26} />
                </div>
                <div className="bottom-nav-text">Dashboard</div>
              </NavLink>
            </div>
            <div className="bottom-nav-item">
              <NavLink to="/create" className="bottom-block">
                <div className="bottom-nav-icon">
                  <MdTipsAndUpdates size={26} />
                </div>
                <div className="bottom-nav-text">Create</div>
              </NavLink>
            </div>
            <div className="bottom-nav-item">
              <NavLink to="/mystories" className="bottom-block">
                <div className="bottom-nav-icon">
                  <HiMiniRectangleStack size={26} />
                </div>
                <div className="bottom-nav-text">My Creations</div>
              </NavLink>
            </div>
            <div
              className="bottom-nav-item flex flex-col justify-center items-center"
              onClick={toggleDrawer(true)}
            >
              <div className="bottom-nav-icon">
                <MdMoreHoriz size={26} />
              </div>
              <div className="bottom-nav-text">More</div>
            </div>
          </div>
        </Paper>
      )}
      <Drawer
        anchor={"bottom"}
        open={showBottomDrawer}
        onClose={toggleDrawer(false)}
        sx={
          {
            // zIndex: 450,
          }
        }
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
      >
        <Paper
          sx={{
            // marginBottom: "72px",
            borderTopRightRadius: "20px",
            borderTopLeftRadius: "20px",
            p: 2,
            pb: 8,
          }}
          elevation={3}
        >
          <div>
            <div className="flex justify-between">
              <span className="font-semibold font-lg">More</span>
              <span>
                <IoCloseOutline size={25} onClick={toggleDrawer(false)} />
              </span>
            </div>
            <div className="pt-4 pb-6 flex flex-col gap-3">
              <NavLink to="/lesson-plan" onClick={toggleDrawer(false)}>
                <div className="flex items-center gap-3">
                  <span>
                    <HiMiniBookOpen size={22} />
                  </span>
                  <span>Lesson Plans</span>
                </div>
              </NavLink>
              <NavLink to="/myplans" onClick={toggleDrawer(false)}>
                <div className="flex items-center gap-3">
                  <span>
                    <BiSolidPurchaseTag size={22} />
                  </span>
                  <span>My Plans</span>
                </div>
              </NavLink>
              <NavLink to="/help" onClick={toggleDrawer(false)}>
                <div className="flex items-center gap-3">
                  <span>
                    <BiSupport size={22} />
                  </span>
                  <span>Support</span>
                </div>
              </NavLink>
            </div>
          </div>
        </Paper>
      </Drawer>
    </>
  );
}
